import { Component, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { environment, GINConstants } from '../../environments/environments';
import { HttpClient, HttpClientModule, HttpHeaders} from "@angular/common/http";
import swal from "sweetalert2";
declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;
@Component({
  selector: 'app-upload',
  standalone: true,
  imports: [CommonModule, IconsFreeToolsComponent],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.css'
})
export class UploadComponent {
  @ViewChild("fileInputs") fileInputs;
  showUploadLoader = false;
  profile_id = "";
  docTitle = "Untitled document";
  docContents = "Start typing your text or paste your text here";
  grammar_all_errors = 0;
  grammar_grammar_errors = 0;
  grammar_punctuation_errors = 0;
  grammar_spelling_errors = 0;
  grammar_synonyms_errors = 0;
  grammar_articles_errors = 0;
  countcustomizedresponse: number;
  dataListing: any[] = [];
  dataListingFinal: any[] = [];
  duplicate_list = [];
  isFirstExecution: boolean = true;
  chunks_id = [];
  checkeduk: boolean = false;
  checkedus: boolean = false;
  get_chunk_text = [];
  server_chunks_text;
  savefiletextsonly: string = '';
  doc_id = "";
  word_count;
  char_count;
  notlogin: boolean = false;
  loaderAlert: boolean = false;
  menuafterresponse: boolean = false;
  assistantVisible = true;
  nothingtocheck: boolean = true;
  words_list =[];
  public pickerApiLoaded = false;
  editortext  ='';
  public scope = [
    "profile",
    "email",
    "https://www.googleapis.com/auth/drive.file", 
  ].join(" ");
  public clientId ="859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com";
  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
    private http: HttpClient,
    private elementRef: ElementRef,) {
      this.assistantVisible = true;
      this.nothingtocheck = true
      this.profile_id = localStorage.getItem("profile_id");
    
  
      if(!this.profile_id){
        this.profile_id = '1';
      }
  
      if(this.profile_id == '1' || this.profile_id == null){
        this.notlogin = false;
      }
      else{
        this.notlogin = true;
      }
     
      }
  @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {
    this.openModal();

  }
  openModal() {

    this.modalService.open(this.content,{ backdrop: 'static', keyboard: false , centered: true,windowClass: 'my-class'});
  }
  openModels(content: any, data: any = null) {
    this.modalService.open(content, { size: "lg" })
  }
  closeModal() {
    this.modalService.dismissAll();
  }

  ngAfterViewInit(): void {
  
    if (this.fileInput) {

    } else {
  
    }
  }


  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  public uploadFileSaveRedirect(event): void {
    const create_chunks = 'false';
    this.clearTextHard(); 

    let files: FileList | null = null;
    if (this.fileInput && this.fileInput.nativeElement?.files.length > 0) {
      files = this.fileInput.nativeElement.files;
    }
    else if (event.target?.files.length > 0) {
      files = event.target.files;
    }

    if (!files || files.length === 0) {
      return;
    }

   
    const fileArray: File[] = Array.from(files);

 
    if (files[0].size > 5243000) {
      // this.showAlerts("File should be less than 5 MB.");
        swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
                        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                          <div class="text-center" style="margin-top: 9%;">
                            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                            <div style="width: 323px; height: 64px; margin-left: 77px;">
                              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                                File should be less than 5 MB
                              </p>
                            </div>
                            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                              class="mt-4 butn-alert">Ok</button>
                          </div>
                        </div>
                      `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });
      
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
      // console.log("check")
    } else {
      this.showUploadLoader = true; 

    
      this.apiservice.submitEFile(this.profile_id, fileArray, create_chunks).subscribe(
        (data) => {
          this.handleNewDocDataContents(data);
          this.updateWordCount();
          this.closeModal();
        },
        (error: any) => {
          this.logError(error);
        }
      );
    }

  }

      
    updateWordCount(): void  {

      this.char_count = $("#mm").text().length;
      this.word_count = $("#mm").text().trim().split(" ").length;

  
    }
  private logError(err: Response) {
    let receivedData = err;
    if (err.status === 0) {
    }
    if (err.status === 401) {

    }
  }
  public clearTextHard() {
    $("#mm").text("");
    this.docTitle = "";
    this.docContents = "Start typing your text or paste your text here";

    $("#char_count").text("0");

    $("#stats_typing_speed").html("0 W/M");
    $("#stats_total_words").html("0");
    $("#stats_total_chars").html("0");
    $("#stats_total_minutes").html("0 Min");

    this.grammar_all_errors = 0;
    this.grammar_grammar_errors = 0;
    this.grammar_punctuation_errors = 0;
    this.grammar_spelling_errors = 0;
    this.grammar_synonyms_errors = 0;
    this.grammar_articles_errors = 0;
    this.countcustomizedresponse = 0;
    this.dataListing = [];
    this.dataListingFinal = [];
    this.duplicate_list = [];
  }

  private handleNewDocDataContents(data: Response) {
      localStorage.setItem('file_uploaded', 'true');
    $('#mm').html('');
    this.isFirstExecution = true;
    this.showUploadLoader = false;
    let receivedData = data;
    this.dataListingFinal = [];
    this.dataListing = [];


    $("#mm").html(receivedData['RetCnt'].replace(/&quot;/g, '"').replace(/&#x27;/g, '\'').replace(/&amp;/g, /&/g).replace(/&gt;/g, '>',).replace(/&lt;/g, '<',).replace(/&quot;/g, /"/g).replace(/\n/g, '<br>'));

    this.chunks_id = receivedData['ChkLs'];
 
    var texteditor = $("#mm").text()

    for (let i = 0; i < this.chunks_id.length; i++) {

      this.server_chunks_text = $('#' + this.chunks_id[i]).text();
     
      this.get_chunk_text.push(this.server_chunks_text);

    }
 

  }
  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;
  showingAlert: boolean = false;
  alertMessage: string = '';
  showAlerts(message: string): void {
    this.alertMessage = message;
    this.showingAlert = true;
  }
  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }
  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false; 
  }
  openDropboxChooser(): void {

    const options = {

      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
          // console.error('Unsupported file type');
        }
      },
      cancel: () => { },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5
    };
    Dropbox.choose(options);
    this.closeModal();
  }

  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    
    this.word_count = 0;
    this.char_count = 0;
  
    this.menuafterresponse = false;
  
  
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
      var data = {'file_type':fileType, 'file_path':fileLink};
      this.apiservice.dropboxfile(fileType, fileLink).subscribe(data =>{
   
        let receivedData = data;
        localStorage.setItem('file_uploaded', 'true');
        $("#mm").html(receivedData['RetCnt'].replace(/&quot;/g, '"').replace(/&#x27;/g, '\'').replace(/&amp;/g, /&/g).replace(/&gt;/g, '>',).replace(/&lt;/g, '<',).replace(/&quot;/g, /"/g).replace(/\n/g, '<br>'));
        this.getContent('',receivedData['RetCnt'])
        $("#UpFileModal").modal("hide");
      })
  }


  public gDriveUpload() {
    gapi.load("auth", { callback: this.onAuthApiLoad.bind(this) });
    gapi.load("picker", { callback: this.onPickerApiLoad.bind(this) });
    this.closeModal();
  }
  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }
  isExport : boolean = false;
  handleAuthResult(authResult) {
    $("#UpFileModal").modal("hide");
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
        
        view.setMimeTypes(
          "application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;
                swal({
                  background: "#FFFFFF",
                  title: "Error",
                  html: `
                                 <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 310px; height: 360px;
                                   background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                                   <div class="text-center" style="margin-top: 9%;">
                                     <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                                  
                                       <p class="error text-center mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                                         File should be less than 5 MB
                                       </p>
                                 
                                     <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                                       border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                                       class="mt-4 butn-alert">Ok</button>
                                   </div>
                                 </div>
                               `,
                  showConfirmButton: false,
                  width: "300px",
                  timer: 4000
                });

       
                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close(); 
                    });
                  }
                }, 0);
              }
              else {
                if (e.docs[0].name.split(".")[1] === "pdf") {

           
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://drive.google.com/u/0/uc?id=" +
                    fileId +
                    "&export=download";
                  let profile_id = localStorage.getItem("profile_id");
                  $.ajax({
                    url: "https://secure3.grammarin.com/api/downloadFromDrive",
                    type: "post",
                  
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "pdf",
                      create_chunks: 'true',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
                      localStorage.setItem('file_uploaded', 'true');
                      $("#mm").html(return_data.RetCnt.replace(/&quot;/g, '"').replace(/&#x27;/g, '\'').replace(/&amp;/g, /&/g).replace(/&gt;/g, '>',).replace(/&lt;/g, '<',).replace(/&quot;/g, /"/g).replace(/\n/g, '<br>'));
                      $("#UpFileModal").modal("hide");

                    },
                    error: function (data) {

                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
                <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 310px; height: 400px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                
                <p class="error mt-2 text-center" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                </p>
                
                <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                class=" butn-alert">Ok</button>
                </div>
                </div>
                `,
                        showConfirmButton: false,
                        width: "300px",
                        timer: 4000
                      });
                
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);
                    }
                  });
                } else if (e.docs[0].name.split(".")[1] === "txt") {
              
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://drive.google.com/u/0/uc?id=" +
                    fileId +
                    "&export=download";

                  if (localStorage.getItem("profile_id")) {
                    var profile_id = localStorage.getItem("profile_id");
                  } else {
                    var profile_id = "1";
                  }
                  $.ajax({
                    url: "https://secure3.grammarin.com/api/downloadFromDrive",
                    type: "post",
                   
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "txt",
                      create_chunks: 'true',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
                      this.hideothers = true;
                      localStorage.setItem('file_uploaded', 'true');
                      $("#mm").html(return_data.RetCnt.replace(/&quot;/g, '"').replace(/&#x27;/g, '\'').replace(/&amp;/g, /&/g).replace(/&gt;/g, '>',).replace(/&lt;/g, '<',).replace(/&quot;/g, /"/g).replace(/\n/g, '<br>'));
                      this.homeText = return_data.RetCnt;
                    },
                    error: function (data) {

                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
                <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 310px; height: 400px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                
                <p class="error mt-2 text-center" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                </p>
                
                <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                class=" butn-alert">Ok</button>
                </div>
                </div>
                `,
                        showConfirmButton: false,
                        width: "300px",
                        timer: 4000
                      });
                 
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);
                    }
                  });
                } else if (e.docs[0].name) {
           
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://docs.google.com/feeds/download/documents/export/Export?id=" +
                    fileId +
                    "&exportFormat=docx";
                  let profile_id = localStorage.getItem("profile_id");
                  $.ajax({
                    url: "https://secure3.grammarin.com/api/downloadFromDrive",
                    type: "post",
                 
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "docx",
                      create_chunks: 'true',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {

                      $("#UpFileModal").modal("hide");

                      localStorage.setItem('file_uploaded', 'true');
                      $("#mm").html(return_data.RetCnt.replace(/&quot;/g, '"').replace(/&#x27;/g, '\'').replace(/&amp;/g, /&/g).replace(/&gt;/g, '>',).replace(/&lt;/g, '<',).replace(/&quot;/g, /"/g).replace(/\n/g, '<br>'));
                    },
                    error: function (data) {

                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
                <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 310px; height: 400px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                
                <p class="error mt-2 text-center" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                </p>
                
                <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                class=" butn-alert">Ok</button>
                </div>
                </div>
                `,
                        showConfirmButton: false,
                        width: "300px",
                        timer: 4000
                      });


 
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);

                    }
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }

  
public getContent(event, text){
  var ctrlDown = false,
  ctrlKey = 17,
  cmdKey = 91,
  vKey = 86,
  cKey = 67;
  var editortxt = $("#mm").text();

 this.char_count = $("#mm").text().length;
 this.words_list = $("#mm").text().trim().split(" ");
  this.word_count = this.words_list.length;


  this.editortext = text;
  if (ctrlDown && event.keyCode == vKey) {

    var editortxt = $("#mm").text();
  }

  var editortxt = $("#mm").text();

 this.char_count = $("#mm").text().length;
  this.word_count = $("#mm").text().trim().split(" ").length;



}

}
